import React, { useState } from 'react';
import { ZALO_LINK } from '../constants/links';
import { NAV_LINKS } from '../constants/site-data';

function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-forest text-white">
      <div className="page-container flex items-center justify-between gap-4 py-4">
        <a href="#about" className="flex items-center gap-3 text-white no-underline hover:text-white">
          <img
            src={`${process.env.PUBLIC_URL}/images/logo-96.png`}
            alt="Gà Kitchen Logo"
            width="44"
            height="55"
            className="h-11 w-auto rounded-full bg-white object-contain p-1"
          />
          <span className="flex flex-col leading-[1.1]">
            <span className="font-display text-[22px] font-extrabold tracking-[-0.01em]">Gà Kitchen</span>
            <span className="text-xs uppercase tracking-[0.08em] text-mist-dim">Đặc sản Đà Lạt</span>
          </span>
        </a>

        <button
          type="button"
          className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/30 md:hidden"
          aria-expanded={open}
          aria-controls="main-nav"
          aria-label={open ? 'Đóng menu' : 'Mở menu'}
          onClick={() => setOpen((v) => !v)}
        >
          <svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            {open ? <path d="M6 6l12 12M18 6L6 18" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
          </svg>
        </button>

        <nav
          id="main-nav"
          aria-label="Điều hướng chính"
          className={`${open ? 'flex' : 'hidden'} w-full flex-col gap-1 pb-2 md:flex md:w-auto md:flex-row md:items-center md:pb-0`}
        >
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="px-3.5 py-2.5 text-[15px] font-medium text-mist-light no-underline hover:text-gold"
            >
              {link.label}
            </a>
          ))}
          <a
            href={ZALO_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="btn mt-2 bg-white px-[18px] py-2.5 text-[15px] text-forest hover:bg-cream hover:text-forest md:ml-2 md:mt-0"
          >
            Đặt qua Zalo
          </a>
        </nav>
      </div>
    </header>
  );
}

export default SiteHeader;
